import { writable, readable } from 'svelte/store';
import { io } from "socket.io-client";
const socket = io();
export const WebSocket = readable(socket);
export const in_game = writable(false);
export const is_typing = writable(false);
function get(key, def = "", parse = false) {
    const value = localStorage.getItem(key);
    if (!parse)
        return value || def;
    if (value === null)
        return def;
    return JSON.parse(value);
}
const storedName = get("name");
const storedMode = get("mode", "light");
const storedShowChat = get("show-chat", false, true);
export const name = writable(storedName);
name.subscribe((value) => {
    localStorage.setItem("name", value);
});
export const mode = writable(storedMode);
mode.subscribe((value) => {
    localStorage.setItem("mode", value);
});
export const show_chat = writable(storedShowChat);
show_chat.subscribe((value) => {
    localStorage.setItem("show-chat", JSON.stringify(value));
});
// export const GameInfo: Writable<PlayerInfo> = writable();
export const selected_game = writable("none");
export class Utils {
}
Utils.cache = new Map();
Utils.__id__ = "";
Utils.self_id = writable(Utils.__id__);
Utils.GameStats = writable(null);
socket.on("UpdateGameStats", stats => { Utils.GameStats.set(stats); });
